import { useContext } from 'react';
import ProgressContext, { ProviderContext } from './ProgressContext';

const useProgress = (): ProviderContext => useContext(ProgressContext)
export default useProgress;